import React, { useState } from 'react';
import '../../src/styles/TableStyle.css'; // To apply the table styles
import SubscribeButton from '../components/SubscribeButton';
import BookmarksPage from '../components/BookmarksPage';

const DynamicTable = ({ data }) => {
  const [activeTab, setActiveTab] = useState('PTE');

  // Categorize data by tabs
  const pteData = data.filter(item => 
    item.title === 'Read Aloud' || 
    item.title === 'Repeat Sentence' || 
    item.title === 'Write from Dictation'
  );

  const technologyData = data.filter(item => item.title === 'Technology Learning');
  const englishData = data.filter(item => item.title === 'English Learning');
  const spanishData = data.filter(item => item.title === 'Spanish Learning');
  const teluguData = data.filter(item => item.title === 'Telugu Learning');

  const renderContent = () => {
    let content = [];
    
    switch(activeTab) {
      case 'PTE':
        content = pteData;
        break;
      case 'Technology':
        content = technologyData;
        break;
      case 'English':
        content = englishData;
        break;
      case 'Spanish':
        content = spanishData;
        break;
      case 'Telugu':
        content = teluguData;
        break;
      case 'Bookmarks':
        content = [];
        break;
      default:
        content = [];
    }

    return content.map((section, index) => (
      <div key={index} className="section">
        <h2 className="section-title">{section.title}:</h2>
        {section.data.map((item, i) => (
          <span
            key={i}
            className="pill"
            onClick={() => window.open(item.link, '_blank')}
          >
            {item.month}
          </span>
        ))}
      </div>
    ));
  };

  return (
    <div className="table-container">
      <div className="header-container">
        <h1 className="main-heading">Complete Skill-Building Videos</h1>
        <SubscribeButton />
      </div>
      
      {/* Tab Navigation */}
      <div className="tabs-container">
        <button 
          className={`tab-button ${activeTab === 'PTE' ? 'active' : ''}`}
          onClick={() => setActiveTab('PTE')}
        >
          PTE
        </button>
        <button 
          className={`tab-button ${activeTab === 'Technology' ? 'active' : ''}`}
          onClick={() => setActiveTab('Technology')}
        >
          Technology
        </button>
        <button 
          className={`tab-button ${activeTab === 'English' ? 'active' : ''}`}
          onClick={() => setActiveTab('English')}
        >
          English
        </button>
        <button 
          className={`tab-button ${activeTab === 'Spanish' ? 'active' : ''}`}
          onClick={() => setActiveTab('Spanish')}
        >
          Spanish
        </button>
        <button 
          className={`tab-button ${activeTab === 'Telugu' ? 'active' : ''}`}
          onClick={() => setActiveTab('Telugu')}
        >
          Telugu
        </button>
        <button 
          className={`tab-button ${activeTab === 'Bookmarks' ? 'active' : ''}`}
          onClick={() => setActiveTab('Bookmarks')}
        >
          Bookmarks
        </button>
      </div>

      {/* Tab Content */}
      <div key={activeTab} className="heading-row tab-content-animated">
        {activeTab === 'Bookmarks' ? (
          <BookmarksPage />
        ) : (
          renderContent()
        )}
      </div>
    </div>
  );
};

export default DynamicTable;
